<div class="main-container background-img">
  <div class="container pl-md-0">
    <div class="row pt-3">
      <div class="col col-md-8" *ngFor="let advisor of advisor">
        <a [routerLink]="['/', this.translate.currentLang, 'advisor', advisor.name]" (click)="isShown = false">
          <img [src]="logo | translate" class="ipc-logo" alt="ipc logo">
        </a>
      </div>
     <div class="col col-md-4 col-lang" *ngFor="let advisor of advisor">
        <label for="" *ngIf="advisor.MultiLang === true">
          <button class="lang-btn" (click)="changeLang('en')">EN</button>
          <button class="lang-btn" (click)="changeLang('fr')">FR</button>
        </label>
      </div> 
    </div>
  </div>
  <div class="container mt-5 text-center shadow p-3 mb-5 bg-white rounded">
    <div class="row p-3 p-md-5">
      <div class="col-md-8 offset-md-2" *ngFor="let question of question">
        <!-- Display the current question -->
        <h2 [innerHTML]="question?.category | translate"></h2>
        <p class="mb-4">{{ question?.question | translate}}</p>

        <!-- Create a form for the answers -->

        <form *ngIf="question" novalidate [formGroup]="form">
          <ng-container *ngFor="let answer of question?.answers" >

            <!-- 

      3. bind your answers to a click event : when the user clicks on an answer, store it in the list of answers in the service, and navigate to the next question. This is all done automatically thanks to the service : the question (and its answers) comes from the service, the current question comes from the service, the answers are stored in the service. 

      Go to question.service.ts

    -->
            <label class="btn btn-purple btn-radio btn-rounded active btn-md form-check-label" *ngFor="let advisor of advisor">
              <input checked autocomplete="yes" type="radio" formControlName="answer" name="answer" value="{{answer}}"
                (click)="quiz.validate(answer); router.navigate(['/', this.translate.currentLang, 'advisor', advisor.name, 'question', quiz.questionId + 1])">
              <h5 class="radio-text">{{ answer }}</h5>
            </label>

          </ng-container>
        </form>
        <h5 class="float-left mt-5">{{question?.page}}</h5>
        <mat-progress-bar mode="determinate" value="{{question?.Progress}}">{{question?.Progress}}</mat-progress-bar>
      </div>
    </div>

  </div>
</div>

<footer class="footer">
  <div class="container pl-md-0">
    <div class="row">
      <div class="col-md-12 top-footer-text mt-4 text-center">
       <!--  <h3 class="font-weight-bold">HEAD OFFICE</h3>
        <p>5015 Spectrum Way. Mississauga, ON. Canada</p>
        <p>Phone: <a class="top-footer-text" href="tel:905-212-9799">905-212-9799</a></p>
        <hr class="footer-hr">-->
        <p class="bottom-footer-text">© 2020 <a class="bottom-footer-text" href="https://www.ipcc.ca"
          target="_blank">Investment Planning
          Counsel</a></p>
      </div>
    </div>
  </div>
</footer>